<template>
  <div class="counterparty-create-form-wrapper">
    <BaseFormSection title="Общие данные">
      <BaseFormField
        label="Название"
        for-id="name"
        required
        wide
        :class="fieldGroupClass('name')"
        :filled="fieldIsFilled('name')"
        info-key="counterparty.common"
        :error="errors.name"
        ref="fieldName"
      >
        <base-party-autocomplete
          v-model="localFormData.name"
          placeholder="Введите название организации"
          :invalid="errors.name"
          @select="handlePartySelect"
          @update:modelValue="onFieldInput('name')"
        />
      </BaseFormField>

      <BaseFormField
        label="ИНН"
        for-id="inn"
        required
        :class="fieldGroupClass('inn')"
        :filled="fieldIsFilled('inn')"
        info-key="counterparty.common"
        :error="errors.inn"
        ref="fieldInn"
      >
        <base-party-autocomplete
          v-model="localFormData.inn"
          placeholder="Введите ИНН организации"
          :invalid="errors.inn"
          @select="handlePartySelect"
          @update:modelValue="onFieldInput('inn')"
        />
      </BaseFormField>

      <BaseFormField
        label="КПП"
        for-id="kpp"
        :class="fieldGroupClass('kpp')"
        :filled="fieldIsFilled('kpp')"
        info-key="counterparty.common"
      >
        <base-input
          id="kpp"
          type="text"
          v-model="localFormData.kpp"
          class="form-input"
          @input="onFieldInput('kpp')"
        />
      </BaseFormField>
    </BaseFormSection>

    <BaseFormSection title="Адрес">
      <BaseFormField
        label="Юридический адрес"
        for-id="legal_address"
        span="2"
        :class="fieldGroupClass('legal_address')"
        :filled="fieldIsFilled('legal_address')"
        info-key="counterparty.address"
      >
        <base-input
          id="legal_address"
          type="text"
          v-model="localFormData.legal_address"
          class="form-input"
          @input="onFieldInput('legal_address')"
        />
      </BaseFormField>

      <BaseFormField
        label="Почтовый адрес"
        for-id="postal_address"
        :class="fieldGroupClass('postal_address')"
        :filled="fieldIsFilled('postal_address')"
        info-key="counterparty.address"
      >
        <base-input
          id="postal_address"
          type="text"
          v-model="localFormData.postal_address"
          class="form-input"
          @input="onFieldInput('postal_address')"
        />
      </BaseFormField>

      <BaseFormField
        label="Город"
        for-id="city"
        :class="fieldGroupClass('city')"
        :filled="fieldIsFilled('city')"
        info-key="counterparty.address"
      >
        <base-input
          id="city"
          type="text"
          v-model="localFormData.city"
          class="form-input"
          @input="onFieldInput('city')"
        />
      </BaseFormField>

      <BaseFormField
        label="Улица"
        for-id="street"
        :class="fieldGroupClass('street')"
        :filled="fieldIsFilled('street')"
        info-key="counterparty.address"
      >
        <base-input
          id="street"
          type="text"
          v-model="localFormData.street"
          class="form-input"
          @input="onFieldInput('street')"
        />
      </BaseFormField>

      <BaseFormField
        label="Дом"
        for-id="house"
        :class="fieldGroupClass('house')"
        :filled="fieldIsFilled('house')"
        info-key="counterparty.address"
      >
        <base-input
          id="house"
          type="text"
          v-model="localFormData.house"
          class="form-input"
          @input="onFieldInput('house')"
        />
      </BaseFormField>

      <BaseFormField
        label="Индекс"
        for-id="postal_code"
        :class="fieldGroupClass('postal_code')"
        :filled="fieldIsFilled('postal_code')"
        info-key="counterparty.address"
      >
        <base-input
          id="postal_code"
          type="text"
          v-model="localFormData.postal_code"
          class="form-input"
          @input="onFieldInput('postal_code')"
        />
      </BaseFormField>

      <BaseFormField
        label="Код региона"
        for-id="region_code"
        :class="fieldGroupClass('region_code')"
        :filled="fieldIsFilled('region_code')"
        info-key="counterparty.address"
      >
        <base-input
          id="region_code"
          type="text"
          v-model="localFormData.region_code"
          class="form-input"
          @input="onFieldInput('region_code')"
        />
      </BaseFormField>
    </BaseFormSection>

    <BaseFormSection title="Контактные данные">
      <BaseFormField
        label="Телефон"
        for-id="phone"
        :class="fieldGroupClass('phone')"
        :filled="fieldIsFilled('phone')"
        info-key="counterparty.common"
      >
        <base-input
          id="phone"
          type="text"
          v-model="localFormData.phone"
          class="form-input"
        />
      </BaseFormField>

      <BaseFormField
        label="Email"
        for-id="email"
        :class="fieldGroupClass('email')"
        :filled="fieldIsFilled('email')"
      >
        <base-input
          id="email"
          type="text"
          v-model="localFormData.email"
          class="form-input"
        />
      </BaseFormField>
    </BaseFormSection>

    <BaseFormSection title="Реквизиты">
      <BaseFormField
        label="Банк"
        for-id="bank_name"
        :class="fieldGroupClass('bank_name')"
        :filled="fieldIsFilled('bank_name')"
      >
        <base-bank-autocomplete
          v-model="localFormData.bank_name"
          placeholder="Введите название банка"
          @select="handleBankSelect"
          @update:modelValue="onFieldInput('bank_name')"
        />
      </BaseFormField>

      <BaseFormField
        label="БИК"
        for-id="bik"
        :class="fieldGroupClass('bik')"
        :filled="fieldIsFilled('bik')"
      >
        <base-bank-autocomplete
          v-model="localFormData.bik"
          placeholder="Введите БИК банка"
          @select="handleBankSelect"
          @update:modelValue="onFieldInput('bik')"
        />
      </BaseFormField>

      <BaseFormField
        label="Корр. счёт"
        for-id="correspondent_account"
        :class="fieldGroupClass('correspondent_account')"
        :filled="fieldIsFilled('correspondent_account')"
      >
        <base-input
          id="correspondent_account"
          type="text"
          v-model="localFormData.correspondent_account"
          class="form-input"
          @input="onFieldInput('correspondent_account')"
        />
      </BaseFormField>

      <BaseFormField
        label="Расчётный счёт"
        for-id="account_number"
        :class="fieldGroupClass('account_number')"
        :filled="fieldIsFilled('account_number')"
      >
        <base-input
          id="account_number"
          type="text"
          v-model="localFormData.account_number"
          class="form-input"
        />
      </BaseFormField>
    </BaseFormSection>
  </div>
</template>

<script>
import { regionCodeFromKladrId } from "@/utils/addressUtils";

export default {
  name: "CounterpartyCreateForm",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:formData"],
  data() {
    return {
      localFormData: { ...this.formData },
      errors: {
        name: false,
        inn: false,
      },
    };
  },

  watch: {
    localFormData: {
      handler(newVal) {
        this.$emit("update:formData", newVal);
      },
      deep: true,
    },

    formData: {
      handler(newVal) {
        Object.assign(this.localFormData, newVal);
      },
      deep: true,
    },
  },

  methods: {
    onFieldInput(field) {
      if (field === "name") this.errors.name = false;
      if (field === "inn") this.errors.inn = false;
    },

    fieldIsFilled(field) {
      const value = this.localFormData[field];
      return value !== null && value !== undefined && String(value).trim() !== "";
    },

    fieldGroupClass(field) {
      return {
        "form-group--filled": this.fieldIsFilled(field),
      };
    },

    handlePartySelect(suggestion) {
      if (!suggestion) {
        this.localFormData.name = "";
        this.localFormData.inn = "";
        this.localFormData.kpp = "";
        this.localFormData.city = "";
        this.localFormData.street = "";
        this.localFormData.house = "";
        this.localFormData.legal_address = "";
        this.localFormData.postal_address = "";
        this.localFormData.postal_code = "";
        this.localFormData.region_code = "";
        return;
      }

      const d = suggestion.data || {};
      const addressData = d.address?.data || {};

      this.localFormData.name =
        d.name?.short_with_opf || suggestion.value || "";
      this.localFormData.inn = d.inn || "";
      this.localFormData.kpp = d.kpp || "";
      this.localFormData.city =
        addressData.city || addressData.settlement || "";
      this.localFormData.street = addressData.street || "";
      this.localFormData.house = addressData.house || "";
      this.localFormData.legal_address = d.address?.value || "";
      this.localFormData.postal_address =
        d.address?.unrestricted_value || d.address?.value || "";
      this.localFormData.postal_code = addressData.postal_code || "";
      this.localFormData.region_code =
        addressData.region_code ||
        regionCodeFromKladrId(addressData.region_kladr_id);

      if (this.localFormData.name) this.errors.name = false;
      if (this.localFormData.inn) this.errors.inn = false;
    },

    handleBankSelect(suggestion) {
      if (!suggestion) {
        this.localFormData.bank_name = "";
        this.localFormData.bik = "";
        this.localFormData.correspondent_account = "";
        return;
      }

      const d = suggestion.data || {};

      this.localFormData.bank_name = suggestion.value || "";
      this.localFormData.bik = d.bic || "";
      this.localFormData.correspondent_account =
        d.correspondent_account || "";
    },

    validate() {
      this.errors = {
        name: false,
        inn: false,
      };

      let isValid = true;
      let firstErrorRef = null;

      if (!this.localFormData.name) {
        this.errors.name = true;
        isValid = false;
        if (!firstErrorRef) firstErrorRef = "fieldName";
      }

      if (!this.localFormData.inn) {
        this.errors.inn = true;
        isValid = false;
        if (!firstErrorRef) firstErrorRef = "fieldInn";
      }

      if (!isValid && firstErrorRef) {
        this.$nextTick(() => {
          const el = this.$refs[firstErrorRef];
          if (el) {
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
      }

      return isValid;
    },
  },
};
</script>

<style scoped>
.form-group--filled :deep(.input:not(.invalid)) {
  border-color: #a3cfb4;
  background-color: #f7fbf8;
}

.form-group--filled :deep(.input:not(.invalid):focus) {
  border-color: #6fb78a;
  box-shadow: 0 0 0 3px rgba(111, 183, 138, 0.14);
}
</style>
